export const HEADER_HEIGHT_XL = 64;
export const MENU_WIDTH_XL = 300;
